import type { FragranceRecord } from '../domain/fragrance/types';

export function ProductPlaceholder({ fragrance, compact = false }: { fragrance: FragranceRecord; compact?: boolean }) {
  const initials = fragrance.identity.brand
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('');
  return (
    <div className={`product-placeholder ${compact ? 'compact' : ''}`} aria-label={`Neutral placeholder for ${fragrance.identity.name}. No verified product image.`}>
      <span className="placeholder-index" aria-hidden="true">{initials}</span>
      <div>
        <small>{fragrance.identity.brand}</small>
        <strong>{fragrance.identity.name}</strong>
      </div>
      <em>Image not verified</em>
    </div>
  );
}
